import { render, staticRenderFns } from "./ButtonSpinner.vue?vue&type=template&id=3cd08062"
import script from "./ButtonSpinner.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonSpinner.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports